import { AfterViewInit, Inject,OnDestroy } from '@angular/core';
import { OnInit } from '@angular/core';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { CheckListItem } from 'app/components/check-list/check-list.component';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';
import { SubjectService } from 'app/shared/services/subject.service';
import { TaskTypeService } from 'app/shared/services/task-type.service';
import { TaskService } from 'app/shared/services/task.service';

@Component({
  selector: 'fuse-prompt-email-dialog',
  templateUrl: './prompt-email-dialog.component.html',
  styleUrls: ['./prompt-email-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class FusePromptEmailDialogComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  title = 'Send Email To';
  subjects: any[];
  subjectIdValue: any;
  listOfValues: any[];
  disabled = true;
  readOnly = false;

  selectAllList: CheckListItem[];
  fullNameList: CheckListItem[];

  constructor(
    public dialog: MatDialog,
    public taskService: TaskService,
    public subjectService: SubjectService,
    public subjectTypeService: SubjectTypeService,
    public taskTypeService: TaskTypeService,
    public dialogRef: MatDialogRef<FusePromptEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.subjects = data.subjects;
  }

  ngOnInit() {
    this.setupFullNameList();
    this.setupSelectAll();
  }

  ngOnDestroy() {}

  ngAfterViewInit() {}

  setupFullNameList() {
    if (this.subjects) {
      this.subjects.sort((a, b) => a.fullName.localeCompare(b.fullName));
      this.fullNameList = this.subjects.map(
        (i) =>
          new CheckListItem(i.id, `${i.fullName} | ${i.email}`, false, i.uid)
      );
    }
  }

  setupSelectAll() {
    this.selectAllList = [new CheckListItem(1, 'Select All', false)];
  }

  nameChanged(e) {
    this.listOfValues = this.fullNameList.filter(
      (item) => item.checked === true
    );
    if (this.listOfValues.length === this.fullNameList.length) {
      this.selectAllList[0].checked = true;
    } else {
      this.selectAllList[0].checked = false;
    }
    if (this.listOfValues.length > 0) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }

  selectAllChanged(e) {
    if (this.selectAllList[0].checked) {
      this.fullNameList.forEach((i) => (i.checked = true));
      this.listOfValues = this.fullNameList.filter(
        (item) => item.checked === true
      );
      this.disabled = false;
    } else {
      this.fullNameList.forEach((i) => (i.checked = false));
      this.listOfValues = [];
      this.disabled = true;
    }
  }

  confirmEmail() {
    const uidStrings = [];
    this.listOfValues.forEach((item) => {
      uidStrings.push(item.value);
    });
    this.dialogRef.close({
      uidStrings,
    });
  }
}
